import { BOARDS } from "../data/boards";
import { iconKey } from "../game/types";
import type { IconRef, SentenceToken } from "../game/types";
import Board from "./Board";

interface Props {
  tokens: SentenceToken[];
  onCellClick?: (ref: IconRef) => void;
  showSolutionGloss?: boolean;
}

export default function BoardGrid({ tokens, onCellClick, showSolutionGloss }: Props) {
  const byIcon = new Map<string, SentenceToken>();
  for (const t of tokens) byIcon.set(iconKey(t.icon), t);

  const solutionKeys = showSolutionGloss ? new Set(byIcon.keys()) : undefined;

  return (
    <div className="board-grid">
      {BOARDS.map((b) => (
        <Board
          key={b.id}
          board={b}
          tokensByIcon={byIcon}
          onCellClick={onCellClick}
          showSolutionGlossFor={solutionKeys}
        />
      ))}
    </div>
  );
}
